import { useActiveOrgId } from '~/hooks/org'
import { useAuthUser } from '~/hooks/useAuthUser'

export const useIsOrgOverridden = () => {
  const { user } = useAuthUser()
  const activeOrgId = useActiveOrgId()
  return (
    !!user?.isSplitsAdmin &&
    !!activeOrgId &&
    !user.orgs.some((o) => o.id === activeOrgId)
  )
}
